export const APIURL       = process.env.REACT_APP_API_URL
export const UPLOADURL    = process.env.REACT_APP_UPLOAD_URL
export const APIKEY       = process.env.REACT_APP_API_KEY
export const DefaultTheme = process.env.REACT_APP_THEME